<div class="tool-detail-container">

  <form [formGroup]="detailForm" (ngSubmit)="onSave()" class="tool-form">

    <!-- SCROLL AREA -->
    <div class="tool-form-content">

      <div class="row">
        <div class="col-9 flex" style="display: flex;justify-content: center;">
          <img id="tool_detail_photo"
               class="img-defaultphoto-icon"
               src=""
               style="width:150px; height: 150px;">
        </div>
      </div>

      <div class="row">

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'ID' | translate }}</mat-label>
            <input id="id" matInput formControlName="id">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'TOOLCATEGORY' | translate }}</mat-label>
            <mat-select formControlName="category" (openedChange)="onCategoryDropdownOpened($event)">

              <!-- Suchfeld oben im Aufklappmenü -->
              <div class="p-2 sticky-top bg-white">
                <input
                  #categorySearchInput
                  matInput
                  placeholder="{{ 'SEARCH' | translate }}"
                  [value]="categorySearchQuery()"
                  (input)="categorySearchQuery.set(categorySearchInput.value)"
                  (keydown)="$event.stopPropagation()"
                  class="form-control form-control-sm"
                />
              </div>

              <!-- Gefilterte Kategorien -->
              @for (category of filteredCategories(); track category.id) {
                <mat-option [value]="category">{{ category.name }}</mat-option>
              }

              @if (filteredCategories().length === 0) {
                <mat-option disabled>{{ 'NO_RESULTS' | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (!hasCategories()) {
            <mat-error>{{ 'CATEGORIES.MISSING' | translate }}</mat-error>
          }
        </div>

        <div class="col-3 flex">
          <mat-form-field class="w-100">
            <mat-label>{{ 'RFID' | translate }}</mat-label>
            <input id="rfid" matInput formControlName="rfid">
            <mat-error>{{ FormErrorHelper.getErrorMessage(detailForm.controls.rfid) }}</mat-error>
          </mat-form-field>
        </div>

      </div>

      <div class="row">

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'DATE.ACQUISITION' | translate }}</mat-label>
            <input matInput [matDatepicker]="acquisitionDatePicker" formControlName="acquisitionDate">
            <mat-hint>{{ 'DATE.FORMAT' | translate }}</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="acquisitionDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #acquisitionDatePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'DATE.LAST_TRANSACTION_DATE' | translate }}</mat-label>
            <input id="lastTransactionDate" matInput formControlName="lastTransactionDate">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field  class="w-100">
            <mat-label>{{ 'MANUFACTURER.MANUFACTURER' | translate }}</mat-label>
            <mat-select formControlName="manufacturer">
              @for (manufacturer of manufacturers; track manufacturer) {
                <mat-option [value]="manufacturer">{{ manufacturer.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <div class="row">

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'PRODUCT.NAME' | translate }}</mat-label>
            <input id="productName" matInput formControlName="productName">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'WARRANTY.CHOOSE_WARRANTY_UNTIL' | translate }}</mat-label>
            <input matInput [matDatepicker]="warrantyUntilDatePicker" formControlName="warrantyUntil">
            <mat-hint>{{ 'DATE.FORMAT' | translate }}</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="warrantyUntilDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #warrantyUntilDatePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'SERIALNUMBER' | translate }}</mat-label>
            <input id="serialNumber" matInput formControlName="serialNumber">
          </mat-form-field>
        </div>

      </div>

      <div class="row">

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'ACQUISITION_PRICE' | translate }}</mat-label>
            <input id="acquisitionPrice" #acquisitionPrice matInput formControlName="acquisitionPrice">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'INVENTORY_NUMBER' | translate }}</mat-label>
            <input id="inventoryNumber" matInput formControlName="inventoryNumber">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'UNIT_NUMBER' | translate }}</mat-label>
            <input id="unitNumber" matInput formControlName="unitNumber">
          </mat-form-field>
        </div>

      </div>

      <div class="row">

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'LENGTH' | translate }}</mat-label>
            <input id="length" #length matInput formControlName="length">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'WIDTH' | translate }}</mat-label>
            <input id="width" #width matInput formControlName="width">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'HEIGHT' | translate }}</mat-label>
            <input id="height" #height matInput formControlName="height">
          </mat-form-field>
        </div>

      </div>

      <div class="row">

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'LOCATION.LOCATION' | translate }}</mat-label>
            <input id="locationPretty" matInput formControlName="locationPretty">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'PROJECT.PROJECT' | translate }}</mat-label>
            <input id="currentProjectName" matInput formControlName="currentProjectName">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field  class="w-100">
            <mat-label>{{ 'SUPPLIER' | translate }}</mat-label>
            <mat-select formControlName="supplier">
              @for (supplier of suppliers; track supplier) {
                <mat-option [value]="supplier">{{ supplier.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <div class="row">

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'MAINCATEGORY' | translate }}</mat-label>
            <input id="mainCategoryDesignation" matInput formControlName="mainCategoryDesignation">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'SUBCATEGORY' | translate }}</mat-label>
            <input id="subCategoryDesignation" matInput formControlName="subCategoryDesignation">
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'PROCESSING_TYPE' | translate }}</mat-label>
            <input id="toolProcessingTypeName" matInput formControlName="toolProcessingTypeName">
          </mat-form-field>
        </div>

      </div>


      <div class="row">

        <div class="col-3">
          <mat-form-field  class="w-100">
            <mat-label>{{ 'COSTCENTER' | translate }}</mat-label>
            <mat-select formControlName="costCenters">

              @if (detailForm.controls.costCenters.value) {
                <mat-option [value]="emptyCostCenter">{{ emptyCostCenter.name }}</mat-option>
              }

              @for (costcenter of costCenters; track costcenter.id) {
                <mat-option [value]="costcenter">{{ costcenter.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field class="w-100">
            <mat-label>{{ 'STATUS' | translate }}</mat-label>
            <input id="status" matInput formControlName="status">
          </mat-form-field>
        </div>

      </div>

      <div class="row">
        <div class="col-9">
          <mat-form-field class="w-100">
            <mat-label>{{ 'REMARK' | translate }}</mat-label>
            <textarea id="remark" matInput formControlName="remark" rows="3" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"></textarea>
          </mat-form-field>
        </div>
      </div>

    </div>

      <!-- FIXED FOOTER -->
      <div class="tool-form-footer" *hasPermission="Permission.TOOL_EDIT">
        <div class="col-3 my-2">
          <button type="submit"
                  mat-raised-button
                  class="me-2"
                  color="primary"
                  [disabled]="detailForm.pristine || !detailForm.valid">
            {{ 'SAVE.SAVE' | translate }}
          </button>

          <button type="button"
                  mat-raised-button
                  class="me-2"
                  [disabled]="detailForm.pristine"
                  (click)="onCancel()">
            {{ 'CANCEL' | translate }}
          </button>
        </div>
      </div>

  </form>

</div>
